import types from "./types";

const INITIAL_STATE = {
	ColumnList: null,
	ColumnListError: null,
	ColumnListLoading: false,
};

const columnListReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		//get

		case types.GET_COLUMNS_START:
			return {
				...state,
				ColumnList: null,
				ColumnListError: null,
				ColumnListLoading: true,
			};
		case types.GET_COLUMNS_SUCCESS:
			return {
				...state,
				ColumnList: action.payload,
				ColumnListLoading: false,
			};
		case types.GET_COLUMNS_ERROR:
			return {
				...state,
				ColumnListError: action.payload,
				ColumnListLoading: false,
			};
		case types.GET_COLUMNS_RESET:
			return {
				...state,
				ColumnListError: null,
				ColumnListLoading: false,
			};
		
		default:
			return { ...state };
	}
};

export default columnListReducer;